import React, { useCallback, useContext } from 'react'
import { useAppUserAccess } from './useAppUserAccess'
import { ParentContext } from '../ParentContext'
import { viewDataModes } from 'global/cnr/reducers/DataManagmentReducer'
import { GoogleSheetsContext } from '../GoogleSheetsContext'
import { responsePromiseHandler } from 'global/cnr/reducers/reducerHelpers/reponsePromiseHandler'
import { createTypes } from 'global/cnr/reducers/CreateReducer'
import { createSimpleEvent } from 'global/firestoreData/events/createSimpleEvent'
import { CreateContext } from '../CreateContext'
import { useNavigate } from 'react-router-dom'

export const useCreate = () => {

  const navigate = useNavigate();

  const appUserAccess = useAppUserAccess()
  const { email: authEmail } = appUserAccess ?? {}

  const parentContext = useContext(ParentContext)
  const { states, fn_cls } = parentContext ?? {}
  const { eventInfo_state, paps_state, currentSettings_state } = states ?? {}
  const { pathViews } = paps_state ?? {}

  const googleSheetsContext = useContext(GoogleSheetsContext);
  const { googleSheets_state, googleSheets_handlers } = googleSheetsContext ?? {}
  const { googleSheetsPreview, logging, databaseProjectId } = googleSheets_state ?? {}
  const { handleFunctionResponse } = googleSheets_handlers ?? {}

  const createContext = useContext(CreateContext)
  const { create_handlers, create_state } = createContext ?? {}
  const { handleResponse_create } = create_handlers ?? {}

  const createEventInDatabase = useCallback(async ({
    addModeType,
    config_alt,
    createInfo,
    destination,
    recreate,
    viewDataMode,
  }) => {

    const _createInfo = createInfo ? createInfo : { ...googleSheetsPreview }

    if (!_createInfo.projectData.clientData) {
      _createInfo.projectData.clientData = {
        clientMobileKey: pathViews.clients
      }
    }

    if (destination && destination.clientKey && _createInfo.projectData && _createInfo.projectData.clientData) {
      _createInfo.projectData.clientData.clientMobileKey = destination.clientKey
    }

    switch (viewDataMode) {
      case viewDataModes.createEvent_limited:
        if (_createInfo?.projectData?.dataCollections?.attendees) {
          _createInfo.projectData.dataCollections.attendees = _.fromPairs(_.take(_.toPairs(_createInfo.projectData.dataCollections.attendees), 50));
        }
        break;
      case viewDataModes.createGsEvent:
        if (_createInfo?.projectData?.dataCollections) {
          delete _createInfo?.projectData?.dataCollections
          delete _createInfo?.projectData?.staticViews
          delete _createInfo?.appDataDocuments
          delete _createInfo?.appDataLinks
        }
    }

    const cb = (result) => {
      responsePromiseHandler(result, handleFunctionResponse)
    }

    fn_cls.createEventInDatabase(
      fn_cls,
      cb,
      _createInfo,
      recreate,
      logging,
      pathViews,
      databaseProjectId,
      addModeType,
      config_alt,
      destination)

  }, [])

  const createClientOrEventInDatabase = useCallback(async ({
    createInfo,
    createType,
    addModeType,
  }) => {

    if (createInfo) {

      const { projectData } = createInfo
      let { clientData } = projectData ?? {}
      const { eventData } = projectData ?? {}

      if (clientData) {
        if (clientData.client_mobile_key) {
          clientData.clientMobileKey = clientData.client_mobile_key
        } else {
          clientData.clientMobileKey = clientPathKey
        }
      } else {
        clientData = {
          clientMobileKey: clientPathKey
        }
      }

      if (eventData && !eventData.name) {
        eventData.name = formData.eventName
        eventData.id = formData.eventName
      }

      if (eventData && !eventData.name && formData.name) {
        eventData.name = formData.name
        eventData.id = formData.name
      }

      switch (createType) {

        case createTypes.updateEvent:
          break;

        // IMPORTANT: Create Event
        case createTypes.createEvent:

          // there are 4 different ways to create...
          switch (addModeType) {

            // IMPORTANT: Create Event from `Event Key`
            case _amts.registrationKey:
              const { eventKey, eventId: eid } = formData
              const { clientMobileKey } = clientData ?? {}
              const ek = eventKey ? eventKey : eid
              navigate.push('/createFeedEvent?clientId=' + clientMobileKey + '&eventId=' + ek + '&mode=create&testing=true')
              break;

            // IMPORTANT: Create Event - from `Select`
            case _amts.select:
              createSimpleEvent(database_fns, handleResponse_create, paps_state, createInfo)
              break;

            // IMPORTANT: Create Event - from `subEvent`
            case _amts.subEvent:
              const cb1 = (response_data) => {
                handleResponse_create(response_data, createInfo)
              }
              fn_cls.createEventInDatabase(fn_cls, cb1, createInfo, false, logging, pathViews, databaseProjectId)
              break;

            // IMPORTANT: Create Event - from `Google Sheets`
            case _amts.googleSheets:
              const cb2 = (response_data) => {
                handleResponse_create(response_data, createInfo)
              }
              fn_cls.createEventInDatabase(fn_cls, cb2, createInfo, false, logging, pathViews, databaseProjectId)
              break;

            default:
              const cb3 = (response_data) => {
                handleResponse_create(response_data, createInfo)
              }
              fn_cls.createEventInDatabase(fn_cls, cb3, createInfo, false, logging, pathViews, databaseProjectId)

          }
          break;

        // IM
        case createTypes.createClient:
          const d = { createInfo, forProd: isMeProd(), databaseProjectId, clientKey: action.clientKey }
          fn_cls.createClientInDatabase(d).then(response_data => {
            const { success, error } = response_data
            dispatch({ type: success ? rts.updateSuccess : rts.updateError, error });
            // handleResponse_create(response_data, createInfo)
          }).catch(err => {
            dispatch({ type: rts.updateError, err });
            // handleResponse_create(createResponse(false, 'Not Successfull', createResponseTypes.catchError, err))
          })
          break;

        default:

      }
    }

  }, [])

  return { createEventInDatabase, createClientOrEventInDatabase }

}
